/* paginagewicht 2026-11-04: filters van de categoriepagina. Geladen met defer, vóór rabe-live-filters.js. */
;/* Range-filters: één range-vinkje (.bucket-toggle) zet alle onderliggende
     waarde-checkboxes (.bucket-member) aan/uit; bij verzenden gaan die mee als
     losse filterwaarden (OR binnen één filter). */
  window.rabeInitFilters = function () {
    var form = document.getElementById('CollectionFilters');
    if (!form || form.dataset.rabeInit) return;
    form.dataset.rabeInit = '1';
    function sync(row) {
      var toggle = row.querySelector('.bucket-toggle');
      var members = row.querySelectorAll('.bucket-member');
      if (!toggle || !members.length) return;
      var checked = 0;
      members.forEach(function (m) { if (m.checked) checked++; });
      toggle.checked = checked > 0;
      toggle.indeterminate = checked > 0 && checked < members.length;
    }
    function submitFilters() {
      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }
    form.querySelectorAll('.bucket-row').forEach(sync);
    form.addEventListener('change', function (e) {
      var t = e.target;
      var shouldSubmit = t.matches && t.matches('input[type="checkbox"]') && !t.disabled;
      /* live-interactie: in het venster "Toon alle" meerdere waarden kunnen aanvinken; toepassen bij sluiten */
      if (shouldSubmit && t.closest && t.closest('.filter-modal')) { modalDirty = true; shouldSubmit = false; }
      if (t.classList && t.classList.contains('bucket-toggle')) {
        var row = t.closest('.bucket-row');
        if (!row) return;
        row.querySelectorAll('.bucket-member').forEach(function (m) { m.checked = t.checked; });
        t.indeterminate = false;
      }
      /* een aangevinkte "verborgen" waarde altijd zichtbaar maken in de zijbalk */
      if (t.type === 'checkbox' && t.checked) {
        var cr = t.closest ? t.closest('.check-row') : null;
        if (cr) cr.classList.remove('is-overflow');
      }
      if (shouldSubmit) submitFilters();
    });

    /* "Toon alle X" opent een modal met de volledige, doorzoekbare lijst.
       De echte filter-rijen worden tijdelijk in de modal geplaatst (één bron
       van waarheid: dezelfde checkboxes blijven in het formulier). */
    var modal = form.querySelector('.filter-modal');
    var modalBody = modal ? modal.querySelector('.filter-modal__body') : null;
    var modalTitle = modal ? modal.querySelector('.filter-modal__title') : null;
    var modalQ = modal ? modal.querySelector('.filter-modal__q') : null;
    var hostedRows = null, rowsHome = null, rowsAnchor = null, modalDirty = false;

    function restoreRows() {
      if (hostedRows && rowsHome) { rowsHome.insertBefore(hostedRows, rowsAnchor); }
      hostedRows = rowsHome = rowsAnchor = null;
      if (modalQ) modalQ.value = '';
      if (modalBody) {
        modalBody.querySelectorAll('.check-row.is-hidden').forEach(function (r) { r.classList.remove('is-hidden'); });
      }
    }

    form.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.filter-modal__apply') && modal && modal.close) { e.preventDefault(); modal.close(); return; }
      var b = e.target.closest ? e.target.closest('.filter-more') : null;
      if (b) {
        e.preventDefault();
        if (!modal || !modalBody) return;
        var group = b.closest('.filter-group');
        var rows = group ? group.querySelector('.filter-rows') : null;
        if (!rows) return;
        if (hostedRows) restoreRows();
        rowsHome = rows.parentNode;
        rowsAnchor = rows.nextSibling;
        hostedRows = rows;
        if (modalTitle) modalTitle.textContent = b.getAttribute('data-filter-label') || 'Filter';
        modalBody.appendChild(rows);
        if (modal.showModal) { modal.showModal(); } else { modal.setAttribute('open', ''); }
        if (modalQ) { modalQ.value = ''; modalQ.focus(); }
        return;
      }
      if (e.target.closest && (e.target.closest('.filter-modal__close') || e.target.closest('.filter-modal__cancel'))) {
        e.preventDefault();
        if (modal && modal.close) { modal.close(); } else if (modal) { modal.removeAttribute('open'); restoreRows(); }
      }
    });

    if (modal) {
      /* Escape / sluiten / backdrop -> rijen terugzetten in de zijbalk */
      modal.addEventListener('close', function () { restoreRows(); if (modalDirty) { modalDirty = false; submitFilters(); } });
      modal.addEventListener('click', function (e) {
        if (e.target === modal) { modal.close(); }
      });
    }
    if (modalQ) {
      modalQ.addEventListener('input', function () {
        if (!hostedRows) return;
        var q = modalQ.value.trim().toLowerCase();
        hostedRows.querySelectorAll('.check-row').forEach(function (r) {
          var span = r.querySelector('span');
          var txt = (span ? span.textContent : '').toLowerCase();
          r.classList.toggle('is-hidden', q !== '' && txt.indexOf(q) === -1);
        });
      });
    }
  };
  window.rabeInitFilters();
